// src/components/Pos/AgentStatusBadge.jsx — حالة الخدمة المحلية داخل شاشة نقطة البيع
// يظهر فقط إذا فُتحت الشاشة من الخدمة المحلية (http://localhost:5080)
import React, { useEffect, useState } from "react";

const isAgent = () => typeof window !== "undefined" && window.__PROFIT_AGENT__ === true;

export default function AgentStatusBadge() {
  const [s, setS] = useState(null);

  useEffect(() => {
    if (!isAgent()) return undefined;
    let alive = true;
    const tick = () =>
      fetch("/agent/status", { cache: "no-store" })
        .then(r => r.json())
        .then(d => { if (alive) setS(d); })
        .catch(() => { if (alive) setS(null); });
    tick();
    const id = setInterval(tick, 5000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!isAgent() || !s) return null;

  const offline = !s.online;
  const inactive = s.deviceState === "inactive";
  const graceLow = offline && s.graceDaysLeft != null && s.graceDaysLeft < 2;

  const tone = inactive || graceLow
    ? "bg-red-600 text-white"
    : offline
      ? "bg-amber-400 text-amber-950"
      : s.pending > 0 ? "bg-white/25 text-white" : "bg-emerald-500/90 text-white";

  const label = inactive
    ? "الجهاز موقوف"
    : offline
      ? `بدون إنترنت${s.pending ? ` · ${s.pending} بانتظار الترحيل` : ""}`
      : s.pending > 0 ? `جارٍ الترحيل · ${s.pending}` : "متصل";

  const title = [
    s.deviceName ? `الجهاز: ${s.deviceName} (${s.deviceNo})` : null,
    s.rejected ? `فواتير مرفوضة: ${s.rejected} (راجع شاشة الأجهزة)` : null,
    offline && s.graceDaysLeft != null ? `متبقي ${s.graceDaysLeft} يوم للعمل بدون اتصال` : null,
    s.lastError ? `ملاحظة: ${s.lastError}` : null,
  ].filter(Boolean).join("\n");

  return (
    <a
      href="/agent"
      target="_blank"
      rel="noreferrer"
      title={title}
      className={`inline-flex items-center gap-1.5 h-9 px-3 rounded-lg text-xs font-bold whitespace-nowrap ${tone}`}
    >
      <span className={`h-2 w-2 rounded-full ${offline || inactive ? "bg-current" : "bg-white"} ${!offline && s.pending > 0 ? "animate-pulse" : ""}`} />
      {label}
      {s.rejected > 0 && <span className="ms-1 px-1.5 rounded bg-red-600 text-white">{s.rejected}</span>}
    </a>
  );
}
